<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="dutyTimeAllowanceAudits && dutyTimeAllowanceAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="dutyTimeAllowanceAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Duty Time audits </ng-template>
</ng-template>
